import ADMIN from './../assets/img/ADMIN.jpg';
import CIVIL from './../assets/img/CIVIL.jpg';
import COMP from './../assets/img/COMP.jpg';
import EDU from './../assets/img/EDU.jpg';
import EXTC from './../assets/img/EXTC.jpg';
import IT from './../assets/img/IT.jpg';
import LEISURE from './../assets/img/LEISURE.jpg';
import LIBRARY from './../assets/img/LIBRARY.jpg';
import MBA from './../assets/img/MBA.jpg';
import MECH from './../assets/img/MECH.jpg';
import MECHT from './../assets/img/MECHT.jpg';
import CHEM from './../assets/img/CHEM.jpg';

const categories = [
  {
    key: 'EDU',
    title: 'Education Related',
    img: EDU,
  },
  {
    key: 'ADMIN',
    title: 'Administration Work',
    img: ADMIN,
  },
  {
    key: 'LEISURE',
    title: 'Leisure and Recreational Activities',
    img: LEISURE,
  },
  {
    key: 'LIBRARY',
    title: 'Library and Books',
    img: LIBRARY,
  },
  {
    key: 'COMP',
    title: 'Stream Specific: Computers',
    img: COMP,
  },
  {
    key: 'IT',
    title: 'Stream Specific: Information Technology',
    img: IT,
  },
  {
    key: 'EXTC',
    title: 'Stream Specific: Electronics',
    img: EXTC,
  },
  {
    key: 'MECHT',
    title: 'Stream Specific: Mechatronics',
    img: MECHT,
  },
  {
    key: 'MECH',
    title: 'Stream Specific: Mechanical',
    img: MECH,
  },
  {
    key: 'CIVIL',
    title: 'Stream Specific: Civil',
    img: CIVIL,
  },
  {
    key: 'CHEM',
    title: 'Stream Specific: Chemical',
    img: CHEM,
  },
  {
    key: 'MBA',
    title: 'Stream Specific: MBA',
    img: MBA,
  },
];

export default categories;
